import { useMemo } from 'react';
import { map } from 'rxjs/operators';
import { useObservableValue } from '../../hooks/useObservable';
import { wsScanToMap } from '../../pipes';
import { SecurityTypesUtils, type SecurityTypes } from '../../types';
import type { Security } from '../../types/Security';
import { EMPTY_ARRAY } from '../../utils/empty';
import { shouldDeleteSecurityFromIndex, type SecurityMemoryObservable } from './utils';

export function useCFDIndexes(securityMemoryObs: SecurityMemoryObservable) {
  const cfdsObs = useMemo(
    () =>
      securityMemoryObs.pipe(
        map(({ latestMessage }) => latestMessage),
        wsScanToMap<Security, string, SecurityTypes['CFD'], SecurityTypes['CFD']>({
          getUniqueKey: security => security.Symbol,
          getInsertable: security => security,
          newMapEachUpdate: false,
          isRelevant: SecurityTypesUtils.CFD.isType,
          shouldDelete: shouldDeleteSecurityFromIndex,
        }),
        map(cfdsBySymbol => [...cfdsBySymbol.values()])
      ),
    [securityMemoryObs]
  );
  const cfds = useObservableValue(() => cfdsObs, [cfdsObs], EMPTY_ARRAY);

  return useMemo(() => ({ cfds }), [cfds]);
}
